<script setup lang="ts">
import { cardVariants } from "~/components/packet/variant/card/styles";

const packet = inject(keys.currentPacket);

const card = inject(keys.packetVariantCard);

const cheapestVariant = usePrices(
  () => card?.value.variants?.filter(truthy),
);

const showIcon = computed(() => cheapestVariant.value !== "NOT_APPLICABLE" && cheapestVariant.value?.discounted);

const classes = computed(() => cardVariants({ theme: unref(packet)?.theme }));
</script>

<template>
  <!-- TODO: Due to a weird render bug in Safari, we need to put this weird transform on this (and only this) icon. Should be regularly checked to see if its been fixed. -->
  <IconsDiscount
    v-if="showIcon"
    class="z-1 [--background:theme(colors.coral.pop)] [--color:black] [--stroke-width:1.5px] safari-only:[&_span]:!translate-y-[-18%]"
    :class="[classes.shadow(), classes.discount()]"
  />
  <!-- Looks weird to have two icons, but this next one is just for creating the shadow which then stacks below the card -->
  <IconsDiscount
    v-if="showIcon"
    class="z-[-1] fill-[--shadow] drop-shadow-[5px_5px_var(--shadow)]"
    :class="[classes.shadow(), classes.discount()]"
  />
</template>
